import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import { userService } from "../../../_services";
import FilterTagCom from '../FilterTag.jsx';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../ui/card";

// Import modernized widgets
import BarWidget from '../BarWidget';
import LineWidget from '../LineWidget';
import ColumnPieWidget from '../ColumnPieWidget';
import MultiLineWidget from '../MultiLineWidget';
import ClaimWidget from '../Claim';
import TableWidget from '../TableWidget';
import MultiStackBarWidget from '../MultiStackBarWidget';
import DistStackBarWidget from '../DistStackBarWidget';

/**
 * User Dashboard Component
 * Modernized with React hooks - Displays widgets for distributor analytics
 */
function Dashboard({ startDate: propStartDate, endDate: propEndDate, dist_usertype, handeChangefilter }) {
    // Initialize dates
    const getInitialStartDate = () => {
        const stored = localStorage.getItem('User_Start_Date');
        if (stored) return moment(stored).format("YYYYMMDD");
        return moment(new Date().setDate(new Date().getDate() - 30)).format("YYYYMMDD");
    };

    const getInitialEndDate = () => {
        const stored = localStorage.getItem('User_End_Date');
        return stored ? moment(stored).format("YYYYMMDD") : moment(new Date()).format("YYYYMMDD");
    };

    // State
    const [startDate, setStartDate] = useState(getInitialStartDate());
    const [endDate, setEndDate] = useState(getInitialEndDate());
    const [graphData, setGraphData] = useState([]);
    const [filterTagList, setFilterTagList] = useState('');
    const [roleType, setRoleType] = useState('Wholesaler');
    const [roleName, setRoleName] = useState('');
    const [loggedInUserId, setLoggedInUserId] = useState('0');
    const [counter, setCounter] = useState(0);
    const whId = '61';

    useEffect(() => {
        const usermetaData = window.atob(localStorage.getItem('ajs_user_id'));
        const [userId] = usermetaData.split(':');
        setLoggedInUserId(userId);
        setRoleName(userId);
        setRoleType(window.atob(localStorage.getItem('_Host_Pro_type')));

        const filterDataLocal = localStorage.getItem('Advance_Filter');
        setFilterTagList(filterDataLocal && filterDataLocal !== 'null' ? filterDataLocal : '');

        const newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate.toString());

        loadDashboardData();
    }, []);

    useEffect(() => {
        const propStartFormatted = moment(propStartDate).format("YYYYMMDD");
        const propEndFormatted = moment(propEndDate).format("YYYYMMDD");
        const prevHDType = localStorage.getItem('Prev_HD_Type');
        const updatedHDType = localStorage.getItem('Updated_HD_Type');
        const filterLastUpdate = localStorage.getItem('Filter_Last_Update_Time');
        const filterPrevUpdate = localStorage.getItem('Filter_Prev_Update_Time');

        if (
            startDate !== propStartFormatted ||
            endDate !== propEndFormatted ||
            prevHDType !== updatedHDType ||
            filterLastUpdate !== filterPrevUpdate
        ) {
            setStartDate(propStartFormatted);
            setEndDate(propEndFormatted);
            localStorage.setItem('dist_usertype', dist_usertype);

            if (prevHDType !== updatedHDType) {
                localStorage.setItem('Prev_HD_Type', updatedHDType);
            }

            if (filterLastUpdate !== filterPrevUpdate) {
                localStorage.setItem('Filter_Prev_Update_Time', filterLastUpdate);
            }

            loadDashboardData();
        }
    }, [propStartDate, propEndDate, dist_usertype]);

    const loadDashboardData = () => {
        const useStartDate = propStartDate ? moment(propStartDate).format("YYYYMMDD") : startDate;
        const useEndDate = propEndDate ? moment(propEndDate).format("YYYYMMDD") : endDate;

        let apiBaseURL = '/api/userDirect';
        if (dist_usertype === 'All') apiBaseURL = '/api/userAll';
        else if (dist_usertype === 'Override') apiBaseURL = '/api/userOverride';

        let adFilterJson = {};
        try {
            const filterData = localStorage.getItem('Advance_Filter');
            if (filterData && filterData !== 'null') {
                adFilterJson = JSON.parse(filterData);
            }
        } catch (error) {
            console.error('Error parsing filter:', error);
        }

        const stringifiedFilter = JSON.stringify(adFilterJson);
        const filterTime = localStorage.getItem('Filter_Last_Update_Time');
        const claimType = localStorage.getItem('Updated_HD_Type');

        // Build widget configurations
        const widgets = [
            {
                url: `${apiBaseURL}/total_transactions`,
                    type: "Bar_List",
                    title: "Total Transactions",
                    Subtitle: "Total number of transactions for each day",
                    ColorCode: '#313131',
                    DataType: "NA",
                    XlabelString: "Date",
                    YlabelString: "# of Transactions",
                    interval: 'day',
                    id: "WTotalTransaction",
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 0,
                    chart_type: "columnList",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    filtertime: filterTime,
                    rxsClaimType: claimType
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/RXSClaims`,
                    type: "Claim",
                title: "",
                    Subtitle: "",
                    ColorCode: "#313131",
                    id: "RxSensClaim",
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 0,
                    chart_type: "list",
                    filtertime: filterTime,
                    rxsClaimType: claimType,
                    wholesaler_id: whId
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/group_number_transactions`,
                    type: "Bar_List",
                    title: "Transactions by Group Number",
                    Subtitle: "Number of transactions for each group number",
                    ColorCode: "#313131",
                    DataType: "GroupNumber",
                    XlabelString: "Group Number",
                    YlabelString: "# of Transactions",
                    id: "WGroupNumberTransaction",
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 30,
                    chart_type: "columnList",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    filtertime: filterTime,
                    rxsClaimType: claimType,
                    wholesaler_id: whId
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/avg_PaitentSavings_values_percent`,
                    type: "Line_List",
                    title: "Average Patient Savings ($)",
                    Subtitle: "Average savings for all patients in $",
                    ColorCode: '#313131',
                    DataType: "NA",
                    XlabelString: "Date",
                    YlabelString: "Total Savings",
                    id: "WPatientSavings_Value",
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 0,
                    chart_type: "lineList",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    filtertime: filterTime,
                    rxsClaimType: claimType,
                    wholesaler_id: whId
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/avg_PaitentSavings_values_percent`,
                    type: "Line_List",
                    title: "Average Patient Savings (%)",
                    Subtitle: "Average savings for all patients in %",
                    ColorCode: '#313131',
                    DataType: "NA",
                    XlabelString: "Date",
                    YlabelString: "Total Savings",
                    id: "WPatientSavings_Percent",
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 0,
                    chart_type: "lineList",
                    ispatientsaving: "false",
                    pharmacynumber: "all",
                    filtertime: filterTime,
                    rxsClaimType: claimType,
                    wholesaler_id: whId
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/state_transaction`,
                    type: "Column_Pie",
                    title: "Transactions by State",
                    Subtitle: "Number of transactions in each state",
                    ColorCode: "#313131",
                    DataType: "DrugName",
                    XlabelString: "Date",
                    YlabelString: "# of Unique Member ID's",
                    interval: 'day',
                    id: "DStateTransaction",
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 30,
                    chart_type: "pielist",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    filtertime: filterTime,
                    rxsClaimType: claimType,
                    wholesaler_id: whId
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/pharmacy_transaction`,
                    type: "List",
                    title: "Transactions by Pharmacy",
                    Subtitle: "Number of transactions at each pharmacy",
                    ColorCode: "",
                    XlabelString: "",
                    YlabelString: "",
                    id: "DPharmacyTransaction",
                    BorderRadius: 0,
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 30,
                    chart_type: "list",
                    filtertime: filterTime,
                    rxsClaimType: claimType
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/drug_transaction`,
                    type: "List",
                    title: "Transactions by Drug",
                    Subtitle: "Number of transactions for each drug",
                    ColorCode: "",
                    XlabelString: "",
                    YlabelString: "",
                    id: "DDrugTransaction",
                    BorderRadius: 0,
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 30,
                    chart_type: "list",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    filtertime: filterTime,
                    rxsClaimType: claimType,
                    wholesaler_id: whId
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/earned_commission`,
                    type: "MultiStackBar_List",
                    title: "Total Revenue Earned",
                    Subtitle: "Revenue earned for each month",
                    ColorCode: "#f19f57",
                    DataType: "NA",
                    XlabelString: "Date",
                    YlabelString: "Commission",
                    interval: 'month',
                    id: "WEarnedCommission",
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 0,
                    chart_type: "column_multiaxislist",
                    ispatientsaving: "true",
                    pharmacynumber: "all",
                    filtertime: filterTime,
                    rxsClaimType: claimType
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/dist_subdist_transactions`,
                    type: "List",
                    title: "Transactions (Sub-Distributors)",
                    Subtitle: "Transactions including sub-distributors",
                    XlabelString: "",
                    YlabelString: "",
                    ColorCode: "",
                    id: "DTransactions",
                    BorderRadius: 0,
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 30,
                    chart_type: "list",
                    filtertime: filterTime,
                    rxsClaimType: claimType
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/prescriber_transaction`,
                    type: "List",
                    title: "Transactions by Prescriber",
                    Subtitle: "Number of transactions at each Prescriber",
                    ColorCode: "",
                    XlabelString: "",
                    YlabelString: "",
                    id: "WPrescriberTransaction",
                BorderRadius: 0,
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 30,
                    chart_type: "list",
                    filtertime: filterTime,
                    rxsClaimType: claimType
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/patient_savings_transaction`,
                    type: "List",
                    title: "Patient Savings by Pharmacy",
                Subtitle: "Patient savings at each pharmacy",
                    ColorCode: "",
                    XlabelString: "",
                    YlabelString: "",
                    id: "DPatientSavingTransaction",
                    BorderRadius: 0,
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 30,
                    chart_type: "list",
                    filtertime: filterTime,
                    rxsClaimType: claimType
                }),
                RequestJson1: stringifiedFilter
            },
            {
                url: `${apiBaseURL}/repeat_prescription_transaction`,
                    type: "List",
                title: "Repeat Prescriptions",
                Subtitle: "Number of repeat prescriptions",
                    ColorCode: "",
                    XlabelString: "",
                    YlabelString: "",
                    id: "WRepeat_PrescriptionsTransaction",
                BorderRadius: 0,
                RequestJson: JSON.stringify({
                    wname: loggedInUserId,
                    whname: whId,
                    start_date: useStartDate,
                    end_date: useEndDate,
                    rcount: 30,
                    chart_type: "list",
                    filtertime: filterTime,
                    rxsClaimType: claimType
                }),
                RequestJson1: stringifiedFilter
            }
        ];

        setGraphData(widgets);
        setCounter(prev => prev + 1);
    };

    const handleChangeA = (e) => {
        if (handeChangefilter) {
            handeChangefilter(e);
        }
    };

    // Get widget layout classes
    const getWidgetClasses = (widgetId) => {
        const baseClasses = "bg-white rounded-lg border shadow-sm";
        
        const layoutMap = {
            'WTotalTransaction': 'col-span-12',
            'RxSensClaim': 'col-span-12',
            'WGroupNumberTransaction': 'col-span-12 md:col-span-6',
            'WPatientSavings_Value': 'col-span-12 md:col-span-6',
            'WPatientSavings_Percent': 'col-span-12 md:col-span-6',
            'DStateTransaction': 'col-span-12 md:col-span-6',
            'DPharmacyTransaction': 'col-span-12',
            'DDrugTransaction': 'col-span-12 md:col-span-6',
            'WEarnedCommission': 'col-span-12 md:col-span-6',
            'DTransactions': 'col-span-12',
            'WPrescriberTransaction': 'col-span-12',
            'DPatientSavingTransaction': 'col-span-12 md:col-span-6',
            'WRepeat_PrescriptionsTransaction': 'col-span-12 md:col-span-6'
        };

        return `${baseClasses} ${layoutMap[widgetId] || 'col-span-12'}`;
    };

    // Render widget based on type
    const renderWidget = (widget, index) => {
        const widgetProps = {
            data: widget,
            key: `${widget.type}-${index}`,
            _Index: index,
            handlechangea: handleChangeA
        };

        switch (widget.type) {
            case 'Bar_List':
                return <BarWidget {...widgetProps} />;
            case 'Line_List':
                return <LineWidget {...widgetProps} />;
            case 'Column_Pie':
                return <ColumnPieWidget {...widgetProps} />;
            case 'MultiLine_List':
                return <MultiLineWidget {...widgetProps} />;
            case 'Claim':
                return <ClaimWidget {...widgetProps} />;
            case 'List':
                return <TableWidget {...widgetProps} />;
            case 'MultiStackBar_List':
                return <DistStackBarWidget {...widgetProps} />;
            default:
                return null;
        }
    };

    // Auth check
    if (userService.Check_Null_Empty(localStorage.getItem("ajs_user_id"))) {
        return <Navigate to="/signup" replace />;
    }

    if (window.atob(localStorage.getItem('UserRole')) !== "Distributor") {
        return <Navigate to="/page-not-found" replace />;
    }

                                                        return (
        <div className="w-full space-y-6">
            {/* Filter Tags */}
            <FilterTagCom 
                Rolename={roleName}
                wh_Id={whId}
                Roletype={roleType}
                df={startDate}
                dt={endDate}
                handlechangea={handleChangeA}
                FilterTags={filterTagList}
                Loading={true}
            />

            {/* Widgets Grid */}
            <div className="grid grid-cols-12 gap-6">
                {graphData.map((widget, index) => {
                    // Special handling for Claim widget - no parent card
                    if (widget.type === 'Claim') {
                                                        return (
                            <div 
                                key={`widget-${widget.id}-${index}`}
                                className={getWidgetClasses(widget.id)}
                            >
                                <ClaimWidget 
                                    data={widget}
                                    key={`${widget.type}-${index}`}
                                    _Index={index}
                                    handlechangea={handleChangeA}
                                />
                                                                </div>
                        );
                    }
                    
                    // Regular widgets with card wrapper
                    return (
                        <Card 
                            key={`widget-${widget.id}-${index}`}
                            className={getWidgetClasses(widget.id)}
                        >
                            <CardHeader className="border-b px-6 py-4">
                                <CardTitle className="text-lg font-semibold text-brand-dark">
                                    {widget.title}
                                </CardTitle>
                                {widget.Subtitle && (
                                    <CardDescription className="text-sm text-brand-dark/70 mt-1">
                                        {widget.Subtitle}
                                    </CardDescription>
                                )}
                            </CardHeader>
                            <CardContent className="p-6">
                                {renderWidget(widget, index)}
                            </CardContent>
                        </Card>
                    );
                })}
                                            </div>
                                        </div>
    );
}

export default Dashboard;
